import type { SVGProps } from 'react';
const DawnFlagEU = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-EU_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-EU_svg__a)">
      <path fill="#043CAE" d="M0 0h22v16H0z" />
      <path
        fill="#FFD429"
        fillRule="evenodd"
        d="M10.26 3.42 11 3.2l.741.22-.217-.753.217-.755-.74.221-.741-.22.216.754zm0 10.668.74-.221.741.22-.217-.754.217-.754-.74.22-.741-.22.216.754zm5.978-5.555-.74.221.217-.754-.217-.754.74.22.741-.22-.217.754.217.754zm-11.217.221.741-.22.741.22L6.286 8l.217-.754-.74.22-.742-.22.217.754zm10.516-2.887-.741.22.217-.754-.217-.754.74.22.742-.22-.217.754.216.755zM5.723 11.42l.741-.221.74.22-.216-.753.217-.755-.741.221-.74-.22.216.754zm7.896-7.507-.74.221.217-.754-.217-.754.74.22.741-.22-.217.754.217.754zm-5.978 9.459.74-.22.741.22-.217-.754.217-.755-.74.221-.741-.22.216.754zm7.896-2.173-.741.22.217-.753-.217-.755.74.221.742-.22-.217.754.216.754zM5.723 6.088l.741-.221.74.22-.216-.754.217-.754-.741.22-.74-.22.216.754zm7.896 7.064-.74.221.217-.754-.217-.755.74.221.741-.22-.217.754.217.754zM7.641 4.135l.74-.22.741.22-.217-.754.217-.754-.74.22-.741-.22.216.754z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagEU;
